import { ServiceError } from '@cigna/cigna-for-brokers/shared/util';
import { createAction, props } from '@ngrx/store';
import {
  AgencyListRequest,
  AgencyListRes,
  PostAffirmRequestPayload,
  PostAffirmSuccessRes,
} from './app.model';

export const getAgencyList = createAction('[App Shared] Get Agency List');

export const getAgencyListSuccess = createAction(
  '[App Shared] Get Agency List Success',
  props<{ payload: AgencyListRes }>(),
);

export const getAgencyListFailure = createAction(
  '[App Shared] Get Agency List Failure',
  props<{ error: ServiceError }>(),
);

export const postAffirm = createAction(
  '[App Shared] Post Affirm',
  props<{ request: PostAffirmRequestPayload }>(),
);

export const postAffirmSuccess = createAction(
  '[App Shared] Post Affirm Success',
  props<{
    request: PostAffirmRequestPayload;
    payload: PostAffirmSuccessRes;
  }>(),
);

export const postAffirmFailure = createAction(
  '[App Shared] Post Affirm  Failure',
  props<{ error: ServiceError }>(),
);

export const getKeepAlive = createAction('[App Shared] Get Keep ALive');

export const getKeepAliveFailure = createAction(
  '[App Shared] Get Keep Alive Failure',
  props<{ error: ServiceError }>(),
);

export const getKeepAliveSuccess = createAction(
  '[App Shared] Get Keep Alive Success',
);
